import Jimp from 'jimp';

export default {
  createResizedImage: (file, width, height, mimeType, compressionRate) => {
    if (mimeType !== 'JPEG') {
      throw new Error('Unimplemented mimeType');
    }

    return Jimp.read(file)
      .then(imageToResize => imageToResize.resize(width, height))
      .then(imageToCompress => imageToCompress.quality(compressionRate))
      .then(imageToConvert => imageToConvert.getBase64Async('image/jpeg'));
  },
};
